const initialState = {
  appointments: [],
  payments: [],
  vrVisits: [],
  vrVisitTotal: 0,
  appointment: null,
  total: 0,
  loading: false,
  error: null,
  assigningAgent: false,
  assignmentError: null,
  assignment: null,
};

export const homeVisitReducer = (state = initialState, action) => {
  switch (action.type) {
    // Appointment List
    case "USER_APPOINTMENT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "USER_APPOINTMENT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        appointments: action.payload.data || [],
        total: action.payload.total || 0,
        error: null,
      };

    case "USER_APPOINTMENT_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Payment List  
    case "USER_APPOINTMENT_PAYMENT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "USER_APPOINTMENT_PAYMENT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        payments: action.payload.data || [],
        error: null,
      };

    case "USER_APPOINTMENT_PAYMENT_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Appointment View
    case "USER_APPOINTMENT_VIEW_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "USER_APPOINTMENT_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        appointment: action.payload.data || null,
        error: null,
      };

    case "USER_APPOINTMENT_VIEW_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        appointment: null,
      };

    case "ASSIGN_AGENT_REQUEST":
      return {
        ...state,
        assigningAgent: true,
        assignmentError: null,
      };

    case "ASSIGN_AGENT_SUCCESS":
      return {
        ...state,
        assigningAgent: false,
        assignment: action.payload,
        assignmentError: null,
        appointment: action.payload.data || state.appointment,
      };

    case "ASSIGN_AGENT_FAIL":
      return {
        ...state,
        assigningAgent: false,
        assignmentError: action.payload,
      };

    case "VR_VISIT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "VR_VISIT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        vrVisits: action.payload.data || [],
        vrVisitTotal: action.payload.total || 0,
        error: null,
      };

    case "VR_VISIT_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
